export function getSystemInfo() {
    return {url: "/info/version"}
}

export function getInstallStatus() {
    return {
        url: "/install",
    }
}